<template>
  <v-container class="pt-0">
    <v-row>
      <v-col cols="12" class="text-h6 secondary--text font-weight-bold">
        <template v-if="currentStep.subCategoryName">
          <template v-if="!showTooltip">
            <v-row>
              <v-col class="my-auto text-h6 primary--text font-weight-bold">
                <div class="caption lighttext--text">
                  {{ currentStep.categoryName }}
                </div>
                {{ currentStep.subCategoryName }}
              </v-col>
              <v-spacer class="limited-spacer"></v-spacer>
              <v-col
                cols="auto"
                class="my-auto"
                v-if="
                  currentStep.description ||
                    (currentStep.behaviors || []).length
                "
              >
                <v-btn outlined color="primary" @click="showTooltip = true">
                  More Info
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mb-4"></v-divider>
          </template>
          <survey-question-title-tooltip
            v-else
            :question="currentStep"
            v-on:close="showTooltip = false"
            class="mb-4"
          ></survey-question-title-tooltip>
        </template>
        {{ currentStep.title }}
        <span
          v-if="
            currentStep.type == $questionTypes.FEEDBACK &&
              !survey.isRegistration
          "
          class="primary--text"
        >
          (optional)
        </span>
      </v-col>
    </v-row>
    <survey-question-opinion-scale
      v-if="currentStep.type == $questionTypes.OPINION_SCALE"
      :showRequiredError="showRequiredError"
    ></survey-question-opinion-scale>
    <survey-question-text
      v-else-if="currentStep.type == $questionTypes.TEXT_RESPONSE"
      :showRequiredError="showRequiredError"
    ></survey-question-text>
    <survey-question-multiple-choice
      v-else-if="currentStep.type == $questionTypes.MULTIPLE_CHOICE"
      :showRequiredError="showRequiredError"
    ></survey-question-multiple-choice>
    <survey-feedback
      v-else-if="currentStep.type == $questionTypes.FEEDBACK"
    ></survey-feedback>
    <v-row>
      <v-col cols="auto">
        <v-btn
          outlined
          color="secondary"
          class="mr-2"
          @click="previousStep"
          v-if="step > 1"
        >
          <v-icon>chevron_left</v-icon>Back
        </v-btn>
        <v-btn @click="nextStepCheck" color="secondary">
          <v-icon>{{ btnIcon }}</v-icon>
          {{ btnText }}
        </v-btn>
        <v-btn
          v-if="
            !currentStep.isRequired &&
              currentStep.type != $questionTypes.FEEDBACK
          "
          text
          @click="skip"
          >Skip</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyQuestionOpinionScale from "@/components/survey/SurveyQuestionOpinionScale";
import SurveyQuestionText from "@/components/survey/SurveyQuestionText";
import SurveyQuestionMultipleChoice from "@/components/survey/SurveyQuestionMultipleChoice";
import SurveyQuestionTitleTooltip from "@/components/survey/SurveyQuestionTitleTooltip";
import SurveyFeedback from "@/components/survey/SurveyFeedback";
export default {
  name: "SurveyStep",
  components: {
    SurveyQuestionOpinionScale,
    SurveyQuestionText,
    SurveyQuestionMultipleChoice,
    SurveyQuestionTitleTooltip,
    SurveyFeedback
  },
  data: () => ({ showTooltip: false, showRequiredError: false }),
  watch: {
    next_step_enabled(val) {
      if (val) {
        this.showRequiredError = false;
      }
    }
  },
  computed: {
    btnText() {
      return this.isLastStep ? "Finish" : "Next Step";
    },
    btnIcon() {
      return this.isLastStep ? "check" : "chevron_right";
    },
    isLastStep() {
      return this.step == this.survey.questions.length;
    },
    ...mapGetters({
      currentStep: "survey/current_step",
      next_step_enabled: "survey/next_step_enabled",
      survey: "survey/survey",
      step: "survey/step",
      is_preview: "survey/is_preview"
    })
  },
  methods: {
    nextStep() {
      this.showTooltip = false;
      if (this.is_preview) {
        this.$store.dispatch("survey/nextStep");
        return;
      }
      let question = this.currentStep;
      if (question.type == this.$questionTypes.FEEDBACK) {
        this.$store
          .dispatch("survey/saveSurveyFeedback", {
            value: question.value
          })
          .then(() => {
            this.finishStep();
          });
      } else if (question.type == this.$questionTypes.OPINION_SCALE) {
        this.$store
          .dispatch("survey/saveSurveyAnswer", {
            id: question.id,
            value: question.value
          })
          .then(() => {
            this.finishStep();
          });
      } else {
        this.finishStep();
      }
    },
    finishStep() {
      if (this.isLastStep && !this.is_preview) {
        this.$store.dispatch("survey/completeSurvey");
      } else {
        this.$store.dispatch("survey/nextStep");
      }
    },
    previousStep() {
      this.showTooltip = false;
      this.$store.dispatch("survey/previousStep");
    },
    skip() {
      this.currentStep.skipped = true;
      this.nextStep();
    },
    nextStepCheck() {
      if (this.next_step_enabled) {
        this.nextStep();
      } else {
        this.showRequiredError = true;
      }
    }
  }
};
</script>
